<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="props.item.href"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <BoxIcon padding="8px" class="mr-3">
            <v-icon medium color="white">add</v-icon>
          </BoxIcon>
          <h1 style="display: inline">Editar pase de salida</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <div class="border-container bg-white pa-4">
          <p>
            <BoxIcon padding="8px" class="mr-3" color="secondary">
              <v-icon medium color="white">bookmark</v-icon>
            </BoxIcon>
            <strong class="text-uppercase subheading font-weight-bold">
              información del pase de salida
            </strong>
          </p>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card flat class="border-container" style="overflow: visible">
                <v-card-text class="py-2">
                  <v-radio-group
                    v-model="form.optionDay"
                    hide-details
                    class="mt-0 pa-0 row_group"
                  >
                    <v-radio
                      color="primary"
                      :key="form.optionDay"
                      label="Solo un día"
                      value="ONLY_ONCE"
                      class="ma-0 mr-2"
                    />
                    <v-radio
                      color="primary"
                      :key="form.optionDay"
                      label="Para un periodo"
                      value="RANGE"
                      class="ma-0"
                    />
                  </v-radio-group>
                </v-card-text>
              </v-card>
              <v-card
                flat
                class="border-container mt-3 pt-3 pl-3"
                style="overflow: visible"
              >
                <strong>Título</strong>
                <br />
                <input
                  type="text"
                  class="mt-2"
                  style="
                    height: 40px;
                    width: 100%;
                    max-width: 300px;
                    font-size: 1.2em;
                    border-radius: 3px;
                  "
                  v-model="form.name"
                />
              </v-card>
            </v-flex>
            <v-flex xs12 md6>
              <div class="general_data">
                <v-card
                  flat
                  class="py-2 px-4 border-container"
                  style="overflow: visible"
                >
                  <v-card-text>
                    <v-layout align-center row fill-height>
                      <span class="font-weight-medium body-2">
                        Periodo de validéz del pase de salida
                      </span>
                    </v-layout>
                    <v-layout
                      align-start
                      column
                      fill-height
                      class="mt-2 ml-1 gray--text"
                    >
                      <div class="d-flex">
                        <span style="width: 100px" class="mt-2 mr-2">
                          <strong>Inicia</strong>
                        </span>
                        <v-menu
                          :close-on-content-click="true"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template late v-slot:activator="{ on }">
                            <v-text-field
                              id="first-small"
                              :value="parseTimeFromTimePicker(form.dateStart)"
                              label="Fecha de inicio"
                              prepend-icon="event"
                              readonly
                              solo
                              flat
                              hide-details
                              v-on="on"
                              class="padded"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            header-color="primary"
                            color="secondary"
                            locale="es-419"
                            scrollable
                            v-model="form.dateStart"
                            :min="dateLimitToday"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div v-if="form.optionDay === 'RANGE'" class="d-flex">
                        <span style="width: 100px" class="mt-2 mr-2">
                          <strong> Termina </strong>
                        </span>
                        <v-menu
                          :close-on-content-click="true"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template late v-slot:activator="{ on }">
                            <v-text-field
                              id="first-small"
                              :value="parseTimeFromTimePicker(form.dateEnds)"
                              label="Fecha de inicio"
                              prepend-icon="event"
                              readonly
                              solo
                              flat
                              hide-details
                              v-on="on"
                              class="padded"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            header-color="primary"
                            color="secondary"
                            locale="es-419"
                            scrollable
                            v-model="form.dateEnds"
                            :min="dateLimitToday"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </div>
            </v-flex>
            <Audience
              ref="audienceRef"
              target-type="AUTHORIZATION"
              @selectedAudience="onSelectedAudience"
              @selectedItemsIds="onSelectedItemsIds"
              @ready="onReady"
            >
              <template v-slot:titleTarget>
                <span class="pl-3 body-2 font-weight-medium text-uppercase">
                  Selecciona la audiencia para el pase de salida
                </span>
              </template>
              <template v-slot:titleItems>
                <span
                  class="pt-1 pl-2 body-2 font-weight-medium text-uppercase"
                >
                  Audiencia
                </span>
              </template>
            </Audience>
            <v-flex>
              <v-layout align-center justify-end class="pa-4">
                <v-btn
                  color="primary"
                  flat="flat"
                  class="border-container ma-1"
                  @click="() => $router.back()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  flat="flat"
                  class="border-container ma-1 pa-2"
                  :disabled="!isValidCreateBtn()"
                  @click="createAuthorizations"
                >
                  Crear pase de salida
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <Loading v-model="createOptions.loading" text="Cargando..." />
    <Error v-model="createOptions.showError" :text="createOptions.message" />
    <Success
      v-model="createOptions.showSuccess"
      :text="createOptions.message"
    />
  </div>
</template>

<script>
import { InitialAudienceData } from '../../../../Mixins/audience.js'
import Error from '../../../Dialogs/Error.vue'
import Loading from '../../../Dialogs/Loading.vue'
import Success from '../../../Dialogs/Success.vue'
import ArrowStep from '../../../generic/arrowStep.vue'
import Audience from '../../../generic/audience.vue'
import BoxIcon from '../../../generic/boxIcon.vue'
import CircleNumber from '../../../generic/circleNumber.vue'
import CustomChip from '../../../generic/customChip.vue'
import RadioBox from '../../../generic/radioBox.vue'
import TargetAudience from '../../../generic/targetAudience.vue'

export default {
  components: {
    CircleNumber,
    ArrowStep,
    TargetAudience,
    BoxIcon,
    RadioBox,
    CustomChip,
    Loading,
    Error,
    Success,
    Audience,
  },
  data: () => ({
    dateLimitToday: '',
    form: {
      /**
       * @type {'RANGE'|'ONLY_ONCE'}
       */
      optionDay: 'ONLY_ONCE',
      dateStart: '',
      dateEnds: '',
      name: '',
      /**
       * @type {'INSTITUTION'|'LEVELS'|'EXTRA_LEVELS'|'GROUPS'|'SUBGROUPS'|'STUDENTS'}
       */
      target: 'INSTITUTION',
      /**
       * @type {Array<number>}
       */
      selectedItemsIds: [],
    },
    breadcrumbs: [
      {
        text: 'Pases de salida',
        disabled: false,
        href: '/es/panel/authorizations',
      },
      {
        text: 'Editar pase de salida',
        disabled: true,
        href: '/es/panel/authorizations/create',
      },
    ],
    createOptions: {
      showSuccess: false,
      showError: false,
      loading: false,
      message: '',
    },
  }),
  async mounted() {
    this.createOptions.loading = true
    this.dateLimitToday = new Date().toLocaleDateString('sv-SE')
  },
  methods: {
    async onReady() {
      await this.getInfo()
      this.createOptions.loading = false
    },
    async createAuthorizations() {
      try {
        this.createOptions.loading = true

        const body = {
          name: this.form.name,
          type: this.form.optionDay,
          date:
            this.form.optionDay === 'ONLY_ONCE'
              ? this._parseTimeToLocalEpoch(this.form.dateStart)
              : undefined,
          startDate:
            this.form.optionDay === 'RANGE'
              ? this._parseTimeToLocalEpoch(this.form.dateStart)
              : undefined,
          endDate:
            this.form.optionDay === 'RANGE'
              ? this._parseTimeToLocalEpoch(this.form.dateEnds)
              : undefined,
          institutional: this.form.target === 'INSTITUTION',
          levelIds:
            this.form.target === 'LEVELS'
              ? this.form.selectedItemsIds
              : undefined,
          extraLevelIds:
            this.form.target === 'EXTRA_LEVELS'
              ? this.form.selectedItemsIds
              : undefined,
          gradeGroupIds:
            this.form.target === 'GROUPS'
              ? this.form.selectedItemsIds
              : undefined,
          subgroupIds:
            this.form.target === 'SUBGROUPS'
              ? this.form.selectedItemsIds
              : undefined,
          studentIds:
            this.form.target === 'STUDENTS'
              ? this.form.selectedItemsIds
              : undefined,
        }

        await this.$store.dispatch('authorizations/editAuthorizations', {
          data: body,
          idAuthorization: this.$route.params.id,
        })

        this.createOptions.message = 'Pase de salida editado con éxito.'
        this.createOptions.showSuccess = true

        const time = setTimeout(() => {
          this.$router.push({ name: 'authorizations' })
          clearTimeout(time)
        }, 2000)
      } catch (error) {
        console.log(error)
        const customErrors = {
          400: 'No se envió ningún elemento de la audiencia.',
          409: 'Ups, la audiencia seleccionada ya cuenta con pases de salida activos, selecciona otra fecha o audiencia',
        }

        this.createOptions.showSuccess = false
        this.createOptions.showError = true
        this.createOptions.message = customErrors[error.response.status]
          ? customErrors[error.response.status]
          : 'Error al crear pase de salida'
      } finally {
        this.createOptions.loading = false
      }
    },
    isValidCreateBtn() {
      if (
        this.createOptions.loading ||
        this.createOptions.showSuccess ||
        this.createOptions.showError ||
        this.form.name.trim().length === 0 ||
        (this.form.target !== 'INSTITUTION' &&
          this.form.selectedItemsIds.length === 0)
      ) {
        return false
      }
      return true
    },
    /**
     * accept a string like so `"2023-11-01"`
     */
    parseTimeFromTimePicker(date = '') {
      if (date === '') return ''

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    _parseTimeToLocalEpoch(date) {
      const [year, month, day] = date.split('-')
      return new Date(`${month}/${day}/${year}`).getTime()
    },
    onSelectedAudience(selected) {
      this.form.target = selected
    },
    onSelectedItemsIds(ids) {
      this.form.selectedItemsIds = ids
    },
    async initLevelsGradeGroupslevels() {
      try {
        const { data } = await this.$store.dispatch('tutor/getLevelsExtraTool')

        return data.entity
      } catch (error) {
        console.log(error)
        return
      }
    },
    async getInfo() {
      try {
        const { data } = await this.$store.dispatch(
          'authorizations/getAuthorization',
          this.$route.params.id
        )
        const temp = new Map(Object.entries(data.audience))

        let tempAudience = new InitialAudienceData()
        if (temp.get('institutional') === true) {
          tempAudience = new InitialAudienceData('INSTITUTION')
        }
        if (temp.has('levelIds')) {
          tempAudience = new InitialAudienceData('LEVELS', temp.get('levelIds'))
        }
        if (temp.has('extraLevelIds')) {
          tempAudience = new InitialAudienceData(
            'EXTRA_LEVELS',
            temp.get('extraLevelIds')
          )
        }
        if (temp.has('gradeGroupIds')) {
          tempAudience = new InitialAudienceData(
            'GROUPS',
            temp.get('gradeGroupIds')
          )
        }
        if (temp.has('subgroupIds')) {
          tempAudience = new InitialAudienceData(
            'SUBGROUPS',
            temp.get('subgroupIds')
          )
        }
        if (temp.has('studentIds')) {
          tempAudience = new InitialAudienceData(
            'STUDENTS',
            temp.get('studentIds')
          )
        }

        if (data.date !== undefined) {
          this.form.dateStart = new Date(data.date).toLocaleDateString('sv-SE')
        } else {
          this.form.dateStart = new Date(data.startDate).toLocaleDateString(
            'sv-SE'
          )
          this.form.dateEnds = new Date(data.endDate).toLocaleDateString(
            'sv-SE'
          )
        }
        this.form = {
          ...this.form,
          name: data.name,
          optionDay: data.type,
        }
        this.$refs.audienceRef.initialData(tempAudience)
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  padding: 1px;
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}
.pagination {
  display: flex;
  justify-content: center;
}
.loading_height {
  height: 300px;
}
.items_box_pills {
  max-height: 300px;
  overflow-y: scroll;
}
/* reset global css */
::v-deep .v-btn {
  text-transform: initial;
}
::v-deep .v-stepper,
::v-deep .v-stepper__header {
  background-color: initial;
  box-shadow: none;
}
::v-deep .v-stepper__header {
  overflow: hidden;
}
::v-deep .v-stepper__content {
  padding-left: 0;
  padding-right: 0;
}

::v-deep .row_group .v-input--radio-group__input {
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
}
/* generic */
.bg-white {
  background-color: white;
}
</style>
